import { withStyles } from '@material-ui/styles';
import HubScheduledCodesForm from './HubScheduledCodesForm';
import styles from './styles';

export default withStyles(styles)(HubScheduledCodesForm);
